import * as THREE from 'three';

/** Gradient sky dome + sun billboard + 6 blob clouds. Returns group added to scene. */
export function buildSky(scene: THREE.Scene, sunDir: THREE.Vector3): THREE.Group {
  const group = new THREE.Group();
  const geo = new THREE.SphereGeometry(900, 16, 12);
  const top = new THREE.Color('#3d8bff');
  const horizon = new THREE.Color('#bfe3ff');
  const colors = new Float32Array(geo.getAttribute('position').count * 3);
  const pos = geo.getAttribute('position') as THREE.BufferAttribute;
  for (let i = 0; i < pos.count; i++) {
    const t = THREE.MathUtils.clamp(pos.getY(i) / 900, 0, 1);
    const c = horizon.clone().lerp(top, Math.pow(t, 0.6));
    colors.set([c.r, c.g, c.b], i * 3);
  }
  geo.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  const dome = new THREE.Mesh(
    geo,
    new THREE.MeshBasicMaterial({ vertexColors: true, side: THREE.BackSide, fog: false, depthWrite: false }),
  );
  group.add(dome);
  // Sun disc
  const sun = new THREE.Mesh(
    new THREE.CircleGeometry(40, 24),
    new THREE.MeshBasicMaterial({ color: 0xfff6d8, fog: false }),
  );
  sun.position.copy(sunDir.clone().normalize().multiplyScalar(850));
  sun.lookAt(0, 0, 0);
  group.add(sun);
  // 6 flat blob clouds (deterministic LCG, no Math.random)
  const cloudMat = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.85,
    fog: false,
  });
  let seed = 12345;
  const next = (): number => {
    seed = (seed * 16807) % 2147483647;
    return seed / 2147483647;
  };
  for (let i = 0; i < 6; i++) {
    const cl = new THREE.Group();
    for (let j = 0; j < 3; j++) {
      const puff = new THREE.Mesh(new THREE.SphereGeometry(18 + next() * 12, 8, 6), cloudMat);
      puff.position.set(j * 22 - 22, next() * 7 - 3, 0);
      puff.scale.y = 0.45;
      cl.add(puff);
    }
    const a = (i / 6) * Math.PI * 2;
    cl.position.set(Math.cos(a) * 600, 180 + (i % 3) * 40, Math.sin(a) * 600);
    group.add(cl);
  }
  scene.add(group);
  return group;
}
